import React from "react";

import { useLocation, NavLink } from "react-router-dom";

const PageBreadcrumb = ({ value }) => {
  return (
    <>
      {value && (
        <li className="breadcrumb-item text-light" aria-current="page">
          {value}
        </li>
      )}
    </>
  );
};

const Breadcrumb = ({ uri, value }) => {
  let location = useLocation();
  const isActive = uri === location.pathname;
  return (
    <>
      {value && !isActive && (
        <li className="breadcrumb-item">
          <NavLink className="text-light" to={uri}>
            {value}
          </NavLink>
        </li>
      )}
      {value && isActive && (
        <li className="breadcrumb-item text-light" aria-current="page">
          {value}
        </li>
      )}
    </>
  );
};

const Breadcrumbs = ({ category, topic, question, page }) => {
  return (
    <>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb p-3 bg-dark">
          <Breadcrumb value={"Home"} uri={"/"} />
          <Breadcrumb value={category} uri={`/${category}`} />
          <Breadcrumb value={topic} uri={`/${category}/${topic}`} />
          <Breadcrumb
            value={question}
            uri={`/${category}/${topic}/${question}`}
          />
          <PageBreadcrumb value={page} />
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
